import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  // 메뉴 항목 정의
  const menuItems = [
    { label: "배너 관리", key: "banners" },
  ];

  // 현재 경로와 메뉴 key 매칭 (기본값: challenge)
  const currentMenuKey =
    menuItems.find((item) => location.pathname.includes(item.key))?.key ||
    "banners";

  // 메뉴 클릭 핸들러
  const handleMenuClick = ({ key }) => {
    navigate(`/${key}`);
  };

  // 페이지 첫 로딩 시 challenge로 이동
  React.useEffect(() => {
    if (location.pathname === "/") {
      navigate("/banners");
    }
  }, [location, navigate]);

  return (
    <Layout style={{ height: "100vh" }}>
      <Header style={{ color: "#fff", fontSize: "20px", textAlign: "center" }}>
        Hotel Content
      </Header>
      <Layout>
        <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
          <Menu
            mode="inline"
            selectedKeys={[currentMenuKey]} // 현재 활성화된 메뉴
            items={menuItems}
            onClick={handleMenuClick}
          />
        </Sider>
        <Content style={{ padding: "24px", background: "#fff" }}>
          <Outlet /> {/* 현재 선택된 페이지의 내용 */}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
